var _path, _ellipse, _g, _g2, _g3, _circle, _circle2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatalogVaccines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 276,
    height: 276,
    fill: "none",
    viewBox: "0 0 276 276",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF1FF",
    d: "M42.644 241.738c-51.525-29.685-51.525-77.827 0-107.491 51.526-29.663 135.138-29.663 186.691 0 51.553 29.664 51.553 77.806 0 107.491-51.553 29.685-135.138 29.68-186.69 0Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 138,
    cy: 190,
    fill: "#D6E4FF",
    rx: 92,
    ry: 44
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 198,
    cy: 203,
    fill: "#BBCDF2",
    rx: 26,
    ry: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 78,
    x: 174,
    y: 122,
    fill: "#F5F8FF",
    stroke: "#264283",
    strokeWidth: 3,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 38,
    x: 177,
    y: 161,
    fill: "#405B9B",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 12,
    x: 174,
    y: 140,
    fill: "#D6E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#264283",
    strokeWidth: 3,
    d: "M174 140h48M174 152h48"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 8,
    x: 185,
    y: 114,
    fill: "#264283"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 16,
    x: 180,
    y: 100,
    fill: "#264283",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 4,
    x: 188,
    y: 104,
    fill: "#405B9B",
    rx: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 240,
    cy: 207,
    fill: "#BBCDF2",
    rx: 17,
    ry: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 50,
    x: 224,
    y: 155,
    fill: "#F5F8FF",
    stroke: "#264283",
    strokeWidth: 3,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 22,
    x: 227,
    y: 180,
    fill: "#405B9B",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 6,
    x: 231,
    y: 149,
    fill: "#264283"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 12,
    x: 227,
    y: 139,
    fill: "#264283",
    rx: 3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-30 100 175)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 200,
    fill: "#BBCDF2",
    rx: 70,
    ry: 7
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 32,
    x: 16,
    y: 159,
    fill: "#264283",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 10,
    x: 24,
    y: 170,
    fill: "#264283"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 40,
    x: 50,
    y: 155,
    fill: "#264283",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 26,
    x: 58,
    y: 162,
    fill: "#F5F8FF",
    stroke: "#264283",
    strokeWidth: 3,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 18,
    x: 88,
    y: 166,
    fill: "#405B9B",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#264283",
    strokeWidth: 2.5,
    d: "M74 162v9M86 162v6M98 162v9M110 162v6M122 162v9M134 162v6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 14,
    x: 154,
    y: 168,
    fill: "#264283",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#405B9B",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M166 175h13"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 128,
    r: 5,
    fill: "#D6E4FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 232,
    cy: 112,
    r: 4,
    fill: "#D6E4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBCDF2",
    d: "M136 92c4 0 7 3 7 7s-3 7-7 7-7-3-7-7 3-7 7-7Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogVaccines);
export default __webpack_public_path__ + "static/media/catalog-vaccines.e2f341730334af6ff796712e91c9925f.svg";
export { ForwardRef as ReactComponent };